import React from 'react'
import { Card, Modal } from '@st-operations/uikit/src/v2/index'
import pretty from '@st-operations/uikit/lib/pretty.js'

import MappedEvents from '../../../distribution/mapped-events/index.jsx'
import '../../../distribution/styles.scss'
import { MAPPED_EVENT } from '../../../scale-and-coverage/constants.js'

import './styles.scss'
import DeviceTypes from '../../../device-types/index.jsx'
import AssociatedPages from './AssociatedPages.jsx'
import DiffBotInfo from './DiffBotInfo.jsx'

const formatDistributionEventTypeData = (dataArray) => {
  const newDistributionArray = dataArray.map((item) => {
    const roundedPercent = Math.round(item.percentage * 100)
    return {
      ...item,
      eventType: MAPPED_EVENT[item.eventType],
      percent: roundedPercent,
      percentText: `${roundedPercent}%`,
    }
  })

  return newDistributionArray.sort((itemA, itemB) => itemB.size - itemA.size)
}

const MODAL_STYLES = {
  content: 'domain-details-modal__container',
  childWrapper: 'domain-details-modal__wrapper',
  innerWrapper: 'domain-details-modal__inner-wrapper',
  headerClose: 'domain-details-modal__close-button',
}

const DomainDetailsModal = ({
  isOpen,
  onClose,
  domain,
  totalEvents,
  totalUsers,
  percentage,
  deviceTypes,
  eventTypes,
  urls,
  description,
  descriptors,
  industries,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} classes={MODAL_STYLES}>
      <section>
        <header className="domain-details-modal__header">
          <h1 className="domain-details-modal__title">
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="domain-details-modal__link"
              href={`http://${domain}`}
            >
              {domain}
            </a>
          </h1>
          <div className="domain-details-modal__group">
            <h2 className="domain-details-modal__secondary-title">Total Users</h2>
            <p className="domain-details-modal__description">{totalUsers}</p>
          </div>
          <div className="domain-details-modal__group">
            <h2 className="domain-details-modal__secondary-title">Total Events</h2>
            <p className="domain-details-modal__description">{totalEvents}</p>
          </div>
          <div className="domain-details-modal__group">
            <h2 className="domain-details-modal__secondary-title">% of Total Events</h2>
            <p className="domain-details-modal__description">{percentage}</p>
          </div>
        </header>
        <div className="domain-details-modal__content">
          <DiffBotInfo
            description={description}
            descriptors={descriptors?.map(pretty).join(', ')}
            industries={industries?.map(pretty).join(', ')}
          />
          <Card className="domain-details-modal__events">
            <h2 className="domain-details-modal__card-title">Mapped events</h2>
            <MappedEvents data={formatDistributionEventTypeData(eventTypes)} />
          </Card>
          <Card className="domain-details-modal__pages">
            <AssociatedPages pages={urls} />
          </Card>
          <Card className="domain-details-modal__devices">
            <h2 className="domain-details-modal__card-title">Device types</h2>
            <DeviceTypes types={deviceTypes} />
          </Card>
        </div>
      </section>
    </Modal>
  )
}

export default DomainDetailsModal
